export default "__VITE_ASSET__21d3734e__"